import React from 'react'
import { Field } from 'redux-form'
import { Row } from 'react-bootstrap'
import { renderTextField } from '../../fieldRenderers'
import { getNumericValidator, required } from '../../fieldValidators'

const numeric12 = getNumericValidator(12)

function FieldCpa (props) {
  const { label = '', handleOnBlur = () => {}, disabled = false, autoFocus = false } = props

  return (
    <Row className='campos-cea-destare campos-cea-bruto'>
      <Field
        className='cpa-grande'
        name='numero'
        type='text'
        label={label}
        maxLength={11}
        component={renderTextField}
        autoFocus={autoFocus}
        onBlur={handleOnBlur}
        disabled={disabled}
        validate={[required, numeric12]}
        placeholder='10200000000'
      />
    </Row>
  )
}

export default FieldCpa
